
import Vue from 'vue'

Vue.filter('resolveSaleCount', value => {
  if(+value < 10000) {
      return +value
  }
  const count = Math.round((+value / 1000)) / Math.pow(10, 1).toFixed(1)
  return `${count}万` 
})
// 体检预约人数
Vue.filter('resolveSaleCount_w', value => {
  if(+value < 10000) {
      return +value
  }
  const count = Math.round((+value / 1000)) / Math.pow(10, 1).toFixed(1)
  return `${count}w` 
})
